module.exports = __webpack_public_path__ + "img/爱你呀_礼物.a4098db0.png";